import { render } from "./EmotionsItemView.vue?vue&type=template&id=e533fecc"
import script from "./EmotionsItemView.vue?vue&type=script&lang=js"
export * from "./EmotionsItemView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__